<template>
  <div class="article-content">
    <!-- <h3 class="aud-article-title" v-show="newsDetail.title!==''">{{newsDetail.title}}</h3> -->
    <div class="isDiv" v-show="newsDetail.content" v-html="newsDetail.content"></div>
    <!-- <div class="visit-count" v-if="newsDetail.visitNumber">
      阅读：{{newsDetail.visitNumber}}
    </div> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        token: 'NBGy6GkK0j7YaQQy1mD5tgIEXvf1hHf+HA6zFX45sGPGqTTtK0xlBOZ/bJUKrMMzI9kL9tzTuACiSGGvMWpmWDmaEQG39TrTNZ3rouzcbhwbN3D0EAo/iRu/UTd2eAhg8/lzo80KxYaPNqn7kEkK//tL9ewdBPz3Vx940e94i8+qBIT4Y/tMeN3CxsFnX/BM0Qu/rP2TWuPC265UYwMFaXzhxLGBP9tOeJdS6oZ4RYKXIeoSHtEZefeF/0Ne5PpFdZjPGeTCeSLhi0QVNZ+70jSDR0ZiOfQJ5NTNtnT9EOJMGGPZkoevYDS/Wd1LcvI5xPT8hle8hE3TgEdYGc2Z+P4TQ3pEta1RRke+boQK/qNYu1LJkzJtNYIDRsf1bshJFAf5AxjrLvNiDx1pKcwNfgT1w5M/Dvv5yMKwTbI5yGQ=',
        newsDetail: {}
      }
    },
    created() {
      this.$store.commit('changeToken', this.token)

      this.getNewsDetail()
    },
    methods: {
      async getNewsDetail() {
        const params = {
          appId: 'bf4505d3ffed4533856e558daf5373f3',
          exhibitionId: 'd3fd07a9b50e4aeb8c3ded912c4c7d39',
          id: this.$route.params.id,
          languageType: "cn",
          subjectType: "VISITOR",
          terminal: "web",
        }
        const res = await this.$http.getNewsDetail(params)
        if (res.code === 1000) {

          this.newsDetail = res.data

          document.title = this.newsDetail.title
          // 图片内容测试
          // this.newsDetail.content = '<p><img src=\"https://ef-base-rules.oss-cn-beijing.aliyuncs.com/null/9030405__1657078602072.png\" width=\"100\" height=\"100\"/></p><p><img src=\"https://ef-base-rules.oss-cn-beijing.aliyuncs.com/null/28577043__1657078577619.png\" width=\"100\" height=\"100\"/></p><p><img src=\"https://ef-base-rules.oss-cn-beijing.aliyuncs.com/null/51531976__1657078638378.png\" width=\"100\" height=\"100\"/></p><p><img src=\"https://ef-base-rules.oss-cn-beijing.aliyuncs.com/null/5168099__1657078701409.png\" width=\"100\" height=\"100\"/></p><p><img src=\"https://ef-base-rules.oss-cn-beijing.aliyuncs.com/null/84281174__1657078780825.png\" width=\"100\" height=\"100\"/></p>'
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .article-content {
    width: 100%;
    min-height: 100vh;
    background: #ffffff;
    ::v-deep p {
      margin: 0;
    }
    .aud-article-title {
      font-size: 20px;
      text-align: center;
      margin-top: 0;
      padding-top: 1em;
      padding-left: 20px;
      padding-right: 20px;
    }
    .isDiv {
      width: 100%;
      /* padding: 20px 20px 30px; */
      font-size: 0.35rem;
      /* text-indent: 2em; */
      box-sizing: border-box;
      /* ::v-deep img {
        width: 100%;
        height: 100%;
        float: left;
      } */
    }
    .visit-count {
      text-align: right;
      font-size: 10px;
      color: rgba(145, 145, 145, 1);
      padding: 0 20px 30px;
      box-sizing: border-box;
    }
  }

  @media screen and (min-width: 750px) {
    .article-content {
      max-width: 540px;
      margin: 0 auto;
    }
  }
</style>